import Spinner from 'LOGIN/CommonResources/SpinnerLoader/Spinner';
import LoginAPICall from 'LoginAPICall';
import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import 'LOGIN/Components/RequestAccess/requestaccess.css';

class RequestAccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // VARIABLES TO GET PROPS
            instituteUrl: this.props.match.params.instituteUrl,
            requestId: this.props.match.params.requestId,

            // VARIABLES TO GET INSTITUTE DETAILS
            instituteDetailsFetching: false,
            instituteName: '',
            instituteLogo: '',
            isValidURL: false,

            // VARIABLES TO GET REQUEST ACCESS DETAILS
            fetchingRequestAccess: false,
            requestAccessDetails: {},
        };
    }

    componentDidMount() {
        // METHOD CALLED TO GET INSTITUTE DETAILS
        this.apiCallToGetInstituteDetails();
    }

    // API CALL METHOD TO GET INSTITUTE DETAILS
    apiCallToGetInstituteDetails = async () => {
        this.setState({
            instituteDetailsFetching: true
        });

        let requestData = {
            "url": this.props.match.params.instituteUrl,
        };

        let jsonResponse = await LoginAPICall.makeAPICall(
            'getInstituteDataByURL',
            requestData,
            '/api/generic_api.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteDetails();
            }, 1000);
        } else {
            let apiResult = jsonResponse.APIResult.data;
            if(jsonResponse.APIResult.success == 'true' && Object.keys(apiResult).length > 0) {
                this.setState({
                    instituteName: apiResult.InstituteName,
                    instituteLogo: apiResult.InstituteLogo,
                    isValidURL: true,
                    instituteDetailsFetching: false
                }, () => {
                    // METHOD CALLED TO GET REQUEST ACCESS DETAILS
                    this.apiCallToGetRequestAccessDetails();
                });
            }else {
                this.setState({
                    isValidURL: false,
                    instituteDetailsFetching: false
                });
            }
        }
    }

    // API CALL METHOD TO GET REQUEST ACCESS DETAILS
    apiCallToGetRequestAccessDetails = async () => {
        this.setState({
            fetchingRequestAccess: true
        });

        let requestData = {
            "RequestId": this.state.requestId,
        };

        let jsonResponse = await LoginAPICall.makeAPICall(
            'getRequestAccessDetails',
            requestData,
            '/api/accessRequest/accessRequest.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetRequestAccessDetails();
            }, 1000);
        } else {
            if(jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
            }
        }
    }

    render() {
        return (
            <div className="requestAccess-container">
                {
                    this.state.instituteDetailsFetching ?
                        <Spinner />
                    :
                        this.state.isValidURL ?
                            <div className="institute-details">
                                <div className="institute-image">
                                    <img src={this.state.instituteLogo} height="70" width="70" />
                                </div>
                                <div className="institute-details-name">
                                    <h3>{ReactHtmlParser(this.state.instituteName)}</h3>
                                </div>
                            </div>
                        :
                            <div className="invalid-url-message">
                                <span className="invalid-message">Invalid URL.</span>
                            </div>
                }
            </div>
        );
    }
}

export default RequestAccess;